export const wishRoute = ({ user, locationId } = {}) => {
  if (user?.accountType === 'worker') return '/listings';
  if (user?.accountType === 'client' && user?.wish?.address?.place_id) return '/edit-wish';
  const params = new URLSearchParams({ showFields: 'true' });
  if (locationId) params.set('locationId', locationId);
  return `/intake/client?${params.toString()}`;
};
